import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  title= 'DClean';

  constructor() { }

  ngOnInit() { }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/home/home.component.ts